<section>
  <header>
    <div>
      <po-search [p-literals]="searchLiterals" (p-change-model)="handleSearch($event)" [p-search-type]="'trigger'" />
      @if (this.filter) {
      <po-select p-placeholder="Filtra por" [p-options]="filter.options" (p-change)="handleFilter($event)" />
      } @if(filterByPeriod) {
      <po-select p-placeholder="Selecione o período" [p-options]="periodFilters"
        (p-change)="handlePeriodFilter($event)" />
      }
    </div>
    <div>
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </div>
  </header>
  <po-table p-hide-columns-manager="true" p-striped="true" p-sort="true" p-actions-right="true"
    (p-sort-by)="handleSort($event)" [p-items]="tableData()" [p-columns]="tableColumns"
    [p-show-more-disabled]="showMoreDisabled" [p-loading]="loading" [p-loading-show-more]="loadingShowMore"
    (p-show-more)="handleShowMore()">
  </po-table>
</section>